<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h3>Terms of Use and Copyright Notice</h3>
        <p>By taking advantage of this site or the information in the StumptheSpread.com website, newsletters or emails, you are agreeing to these terms and conditions. You must be at least 18 years of age to use our services. The information on this site is for your enjoyment and entertainment purposes only. We are not liable for any losses that incurred as a result of the information purchased through this website. This is not a betting site. Information and recommendations made are for entertainment and informational purposes only. This information is not intended to violate any local, state, or federal laws. Past performance and results do not guarantee future results. Any reliance on such information and recommendations is at the sole discretion and risk of the subscriber.</p>
        <p>Once leaving our site, you are responsible for your actions on other sites that may link from this site. We do not control the content or services of other websites. We also do not encourage any participation in services offered by other websites. Please review the laws in your state and country. You are responsible for your actions and use of information from this site and for your actions once you leave this site.</p>
        <p>If you or anyone you know has a gambling problem, please seek help and start by visiting <a href="https://www.gamblersanonymous.org/ga/">Gamblers Anonymous.</a></p>
        <h5>Refund Policy</h5>
        <p>All sales made to StumptheSpread.com are final. No reimbursements or refunds will be given for any reason.</p>
        <h5>Copyright Notice</h5>
        <p>Copyright © 2009-{{ year }} StumptheSpread.com. All rights reserved.</p>
        <p>Unless otherwise indicated, this site and its contents (including, but not limited to, all text, photographs, images, video, and audio) are the exclusive property of StumptheSpread.com and are protected by copyright, trademark, and other laws.</p>
        <p>Except as may be permitted under the Copyright Act of 1976, you may not reproduce, publish, transmit, distribute, perform, display, modify, create derivative works from, sell, or otherwise exploit this site or any of its contents without our prior written permission.</p>
        <p>You may not, under any circumstances, reproduce materials in print or verbal form or reproduce them on the Internet without express written permission from StumptheSpread.com. Doing so will result in being banned from this site and losing any subscription privileges without refund.</p>
        <p>Any questions or comments may be sent to: policy@stumpthespread.com</p>
      </div>
      <!-- main-colum END here -->
      <sidebar></sidebar>
    </div>
    <!-- container END here -->
  </div>
  <!-- content END here -->
</template>

<script>
import Sidebar from '../components/sidebar.vue'
export default {
  components: {
    'sidebar': Sidebar
  },
  data () {
    return {
      year: new Date().getFullYear()
    }
  },
  metaInfo: {
    title: 'Terms of Use'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Terms.vue?5d16e92c